<div class="page-wrap">
  <div
    class="w-full flex flex-col align-middle *:justify-center bg-container-bg-default sticky top-0 z-10 border border-action-bg-muted">
    <remote-update-domain-user-menu
    class="ml-auto mx-300-rem flex h-300-rem w-300-rem bg-action-bg-muted rounded-full my-2"></remote-update-domain-user-menu>
    <remote-update-domain-app-environment-build-info></remote-update-domain-app-environment-build-info>
  </div>

  @if (!canAccessRoute) {
    <div class="h-full">
      <remote-update-domain-access-denied></remote-update-domain-access-denied>
    </div>
  } @else if (isServerError()) {
    <div class="h-full">
      <remote-update-domain-app-server-error-page></remote-update-domain-app-server-error-page>
    </div>
  } @else if (isPageNotFound()) {
    <div class="h-full">
      <remote-update-domain-app-page-not-found></remote-update-domain-app-page-not-found>
    </div>
  } @else {
    <div class="content-row">
      <section>
        <nav class="sidebar">
          <ul class="sidebar-menu">
            @if(!isDetailsPage) { @for (item of menuItems; track item.label) {
              @if(canAccessMenuRoute(item.path)) {
                <li
                  class="menu-item"
                  routerLink="{{ item.path }}"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: item.path === '/devices' }">
                  {{ item.label }}
                </li>
                } } }

                @if (isDetailsPage) {
                  <li
                    class="menu-item-back flex active cursor-pointer gap-050-em px-150-em items-center justify-start mb-100-rem"
                    [routerLink]="backToPath"
                    routerLinkActive="active">
                    <img src="/svgs/left-arrow.svg" alt="file" />
                    <span>{{ backLabel }}</span>
                  </li>
                  <li class="menu-item-details active">{{ detailsLabel }}</li>
                }
              </ul>
            </nav>
          </section>
          <div class="main-content">
            <router-outlet></router-outlet>
          </div>
        </div>
      }
    </div>
